import { Box, CircularProgress } from '@mui/material';

const LoadingSpinner = ({ fullPage, size = 40 }) => {
  if (fullPage) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <CircularProgress size={size} />
      </Box>
    );
  }
  return <CircularProgress size={size} />;
};

export default LoadingSpinner;
